export enum NotificationTypes {
    NoteMention = 1,
    OpportunityAssignment,
    OpportunityStatusChange,
    OpportunityBidStatusChange,
    ExpiringDueDate,
    ExpiringFollowUpContactDate
}
